import { Path } from "@/navigations/routes";
import { ReactNode } from "react";
import { FooterColumnProps } from "../components/footer/footerColumn";
import Linkedin from "@/assets/svgs/linkedin.svg";
import Facebook from "@/assets/svgs/facebook.svg";
import Instagram from "@/assets/svgs/instagram-icon.svg";
import Twitter from "@/assets/svgs/twitter.svg";

export interface SocialLinksData {
  icon: ReactNode;
  url: string;
  name: string;
}

export const footerColumns: FooterColumnProps[] = [
  {
    title: "Company",
    links: [
      {
        title: "About",
        url: Path.AboutUs,
      },
      {
        title: "Blog",
        url: Path.Blog,
      },
      // {
      //   title: "Newsletter",
      //   url: Path.Newsletter,
      // },
      {
        title: "FAQs",
        url: `${Path.Home}#faq`,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      {
        title: "Terms & Conditions",
        url: Path.TermsAndConditions,
      },
      {
        title: "Privacy Policy",
        url: Path.PrivacyPolicy,
      },
      {
        title: "Cookie Policy",
        url: Path.CookiesPolicy,
      },
      {
        title: "Our Licenses",
        url: Path.LicensesAndCompliance,
      },
    ],
  },
];

export const socialLinks: SocialLinksData[] = [
  {
    url: "https://twitter.com/usesendsprint/",
    icon: <Twitter />,
    name: "twitter link",
  },
  {
    url: "https://www.instagram.com/sendsprintapp/",
    icon: <Instagram />,
    name: "instagram link",
  },
  {
    url: "https://www.facebook.com/sendsprintapp/",
    icon: <Facebook />,
    name: "facebook link",
  },
  {
    url: "https://www.linkedin.com/company/sendsprintapp/",
    icon: <Linkedin />,
    name: "linkedin link",
  },
];
